import { AxiosPromise } from 'axios';

import { orderFormByGuid } from '@/api/microsservices/SquareApi';

export const getOrderFormByGuid = (guid: string): AxiosPromise<string> => {
  return orderFormByGuid.get({
    uriParams: {
      guid,
    },
  });
};